module.exports = __webpack_public_path__ + "static/img/united-kingdom.6f382b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/united-kingdom.png
// module id = 8JBm
// module chunks = 1